<template>
  <basic-layout-dynamic :hide-footer="true">
    <div class="container">
      <div class="contents">
        <blockquote style="font-size: var(--font-size-small);">
          <pre>
            POS開示サイトをご契約のお客様へ

            Duck（データダウンロード）の実行回数は現状集計されません。ご了承ください。
          </pre>
        </blockquote>
      </div>
      <div class="contents">
        <div gl-tooltip="メニュー別CSV出力" gl-tooltip-direction="down">
          <gl-button
            icon-button
            :disabled="menuTable.rows.length === 0"
            @click="menuTableCsvDownload"
          >
            <md-icon> <font-awesome-icon icon="file-csv"/></md-icon>
          </gl-button>
        </div>
        <gl-table v-bind="menuTable" />

        <div gl-tooltip="アカウント別CSV出力" gl-tooltip-direction="down">
          <gl-button
            icon-button
            :disabled="accountTable.rows.length === 0"
            @click="accountTableCsvDownload"
          >
            <md-icon> <font-awesome-icon icon="file-csv"/></md-icon>
          </gl-button>
        </div>
        <gl-table v-bind="accountTable" />
      </div>
      <div class="contents">
        <h4>その他（CSVダウンロードのみのご提供）</h4>
        <div>
          <input
            type="month"
            v-model="accountAndIp.month"
            :disabled="accountAndIp.downloading"
          />
          <a
            href="#"
            @click.prevent="accountAndIpCsvDownload"
            :disabled="accountAndIp.downloading"
          >
            ユーザー・IPアドレス別CSV出力
          </a>
        </div>
      </div>
    </div>
  </basic-layout-dynamic>
</template>

<script>
import GlTable from '@/components/GlTable.vue'
import download from '@/util/download'

export default {
  components: {
    GlTable,
  },
  data() {
    const today = new Date()

    return {
      /**
       * メニュー別側結果
       */
      menuTable: {
        columns: undefined,
        groupHeaders: undefined,
        sortColumnName: 'sort_order',
        sortOrder: 'asc',
        url: undefined,
        width: 1000,
        height: 250,
        rows: [],
        customFormatter: {
          linkify: (rowData, cell) => {
            cell.classList.add('selectable-cell')

            cell.addEventListener('click', () => {
              if (!this.menuTable.columns) {
                throw new Error('Column not found')
              }
              const menuCode = rowData.menu_code
              this.reloadAccountGrid(menuCode)
            })
          },
        },
      },
      /**
       * アカウント別側結果
       */
      accountTable: {
        columns: undefined,
        groupHeaders: undefined,
        sortColumnName: 'login_id',
        sortOrder: 'asc',
        url: undefined,
        width: 1000,
        height: 250,
        rows: [],
      },
      /**
       * アカウント・IPアドレス別
       */
      accountAndIp: {
        month: `${today.getFullYear()}-${('00' + (today.getMonth() + 1)).slice(
          -2,
        )}`,
        downloading: false,
      },
    }
  },
  methods: {
    async reloadAccountGrid(menuCode) {
      const accountRows = await this.$repositories
        .get('queryLog')
        .getAccountRows(menuCode)
      this.accountTable.rows = accountRows.rows
    },
    async menuTableCsvDownload() {
      this.donwload(
        this.menuTable.columns,
        this.menuTable.rows,
        'メニュー別ログイン回数.csv',
      )
    },
    async accountTableCsvDownload() {
      this.donwload(
        this.accountTable.columns,
        this.accountTable.rows,
        'アカウント別ログイン回数.csv',
      )
    },
    async accountAndIpCsvDownload() {
      if (this.accountAndIp.downloading) {
        return
      }

      const repo = this.$repositories.get('queryLog')
      const [year, month] = this.accountAndIp.month.split('-')

      this.accountAndIp.downloading = true

      try {
        const grid = await repo.getAccountAndIpGrid()
        const rows = await repo.getAccountAndIpRows(year, month)
        await this.donwload(
          grid.colModel,
          rows.rows,
          `アカウント・IPアドレス別分析回数(${this.accountAndIp.month}).csv`,
        )
      } catch (e) {
        alert('ダウンロードに失敗しました。')
      } finally {
        this.accountAndIp.downloading = false
      }
    },
    async donwload(columns, rows, fileName) {
      //ヘッダ
      const showColumns = columns.filter(c => !c.hidden)
      let csv = showColumns.map(c => c.headerText).join(',') + '\n'

      //データ
      rows.forEach(r => {
        let arr = []
        showColumns.forEach(c => {
          arr.push(r[c.colName])
        })
        csv += arr.join(',')
        csv += '\n'
      })

      var bom = new Uint8Array([0xef, 0xbb, 0xbf]) //BOM
      var blob = new Blob([bom, csv], { type: 'text/csv' })

      download(blob, fileName)
    },
  },
  async created() {
    const menuGrid = await this.$repositories.get('queryLog').getMenuGrid()
    this.menuTable.columns = menuGrid.colModel
    const menuRows = await this.$repositories.get('queryLog').getMenuRows()
    this.menuTable.rows = menuRows.rows

    const accountGrid = await this.$repositories
      .get('queryLog')
      .getAccountGrid()
    this.accountTable.columns = accountGrid.colModel
  },
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.contents {
  width: auto;
  max-width: 900px;
}
.contents:not(:first-of-type) {
  margin-top: var(--spacing-large);
}
</style>

<style lang="scss">
.c3t-cell {
  &.selectable-cell {
    cursor: pointer;
    color: var(--md-theme-default-primary-on-background, #448aff);
    text-decoration: underline;
  }
}
</style>
